import { useState, useCallback } from 'react'
import { pdf } from 'common/api'

import fileDownload from 'js-file-download'

import { Button, Typography, Box } from '@material-ui/core'

const DownloadScoirApplyProfile = ({
  scid,
  isPermitted,
  applicationId,
  filename = 'Scoir-Apply-Profile.pdf',
}: {
  isPermitted: boolean
  applicationId: string
  filename?: string
  scid: number
}) => {
  const [downloading, setDownloading] = useState(false)
  const [hasError, setHasError] = useState(false)
  const downloadProfile = useCallback(() => {
    setDownloading(true)
    setHasError(false)
    pdf
      .get(`/api/colleges/${scid}/applicants/profile/${applicationId}/pdf`)
      .then((pdfData) => {
        fileDownload(pdfData, filename, 'application/pdf')
        setDownloading(false)
      })
      .catch(() => {
        setHasError(true)
        setDownloading(false)
      })
  }, [scid, filename, applicationId])
  return (
    <Box>
      <Button
        disabled={downloading || !isPermitted}
        variant="contained"
        color="primary"
        onClick={downloadProfile}
      >
        Download Application PDF
      </Button>
      {hasError && (
        <Box mt={1}>
          <Typography
            role="alert"
            color="error"
            align="center"
          >
            An error occurred while downloading the profile
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default DownloadScoirApplyProfile
